module.exports = __webpack_public_path__ + "assets/views/01_aboutPadcev/graph_MOA.png";